/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { gnoment } from 'shared-ui/gnoment';
import PropTypes from 'prop-types';
import { VehicleTypes, WatercraftTypes, Durations } from '../constants';

export const HolderInfoProps = PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    company_name: PropTypes.string,
    email: PropTypes.string,
});

export const HolderInfoDefaults = {
    first_name: '',
    last_name: '',
    email: '',
};

export const VehicleInfoProps = PropTypes.shape({
    type: PropTypes.oneOf(Object.keys(VehicleTypes)),
    fields: PropTypes.shape({
        license: PropTypes.string,
    }),
});

export const VehicleInfoDefaults = {
    type: '',
    fields: {
        license: '',
    },
};

export const WatercraftInfoProps = PropTypes.shape({
    type: PropTypes.oneOf(Object.keys(WatercraftTypes)),
    fields: PropTypes.shape({
        license: PropTypes.string,
    }),
});

export const WatercraftInfoDefaults = {
    type: 'motorized-boat',
    fields: {
        license: '',
    },
};

export const PassInfoProps = PropTypes.shape({
    duration: PropTypes.oneOf(Object.keys(Durations)),
    facility_name: PropTypes.string,
    features: PropTypes.shape({
        'attendee-info': PropTypes.objectOf(PropTypes.number),
        'equipment-info': PropTypes.shape({
            vehicle: VehicleInfoProps,
            watercraft: WatercraftInfoProps,
        }),
        'start-date': PropTypes.string,
        'duration-of-visit': PropTypes.number,
        'bus-number': PropTypes.string,
        'number-of-passengers': PropTypes.number,
    }),
    holder_info: HolderInfoProps,
    pass_image: PropTypes.string,
    pass_name: PropTypes.string,
    end_date: PropTypes.string,
    start_date: PropTypes.string,
});

export const PassInfoDefaults = {
    duration: 'annual',
    facility_name: '',
    features: {
        'attendee-info': { adults: 1, visitors: 0 },
        'equipment-info': {
            vehicle: VehicleInfoDefaults,
            watercraft: WatercraftInfoDefaults,
        },
        'start-date': gnoment().startOf('day').format(),
    },
    holder_info: HolderInfoDefaults,
    pass_image: '',
    pass_name: '',
    end_date: null,
    start_date: null,
};
